import React, { useState, useEffect } from 'react';

import { Typography } from '@mui/material';

function BranchName() {
  const [branch, setBranch] = useState(null);

  useEffect(() => {
    const fetchBranchData = async () => {
      if (typeof window === 'undefined') return;

      await new Promise((resolve) => setTimeout(resolve, 100));

      const jwtToken = localStorage.getItem('jwt_access_token');
      if (!jwtToken) return;

      const branchData =
        localStorage.getItem('selected_branch') || localStorage.getItem('branches_short_key');

      if (branchData) {
        try {
          setBranch(JSON.parse(branchData));
        } catch (error) {
          console.error('Error parsing branch data:', error);
        }
      }
    };

    fetchBranchData();
  }, []);

  if (!branch) return null;

  return <Typography variant="h6">{branch?.branchName || ''}</Typography>;
}

export default BranchName;
